export const personAbsencesSelector = state => state.personAbsences;
